import { render, staticRenderFns } from "./FormularioLibro.vue?vue&type=template&id=7080c7dd&"
import script from "./FormularioLibro.vue?vue&type=script&lang=js&"
export * from "./FormularioLibro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports